import React from "react";
import Table from "../list/Table";
import { Link } from "react-router-dom";
import { IoMdPersonAdd } from "react-icons/io";
import { useTranslation } from "react-i18next";
import objectPath from "object-path";
import { API_ROOT } from "../defines";
import moment from "moment";
const List = () => {
  const { t } = useTranslation();
  const GroupList = [
    {
      label: t("sign.material"),
      value: "material",
    },
    {
      label: t("sign.size"),
      value: "size",
    },
  ];
  return (
    <div className="flex flex-col ">
      <div className="flex items-center justify-between w-full h-20 py-3 px-8">
        <div className="text-xl font-semibold leading-5 text-black ">
          {t("material.name")}
        </div>
        <Link
          to={`new`}
          className="p-2 border-2 rounded hover:cursor-pointer border-primary"
        >
          <IoMdPersonAdd color="#1A2E55" />
        </Link>
      </div>
      <div className="px-4">
        <Table
          url={`/consts/table`}
          sort={{ _id: -1 }}
          columns={[
            {
              label: t("type.name"),
              key: `name`,
              sort: true,
              filter: {
                type: "text",
              },
              render: ({ _id, name }) => {
                return (
                  <Link to={`view/${_id}`}>
                    <div className="text-primary underline font-semibold">
                      {name}
                    </div>
                  </Link>
                );
              },
            },
            {
              label: t("type.type"),
              key: `group`,
              sort: true,
              filter: {
                type: "select",
                items: GroupList,
              },
              render: ({ group }) => {
                const temp = GroupList.filter((row) => row.value == group);
                return <div>{temp[0]?.label}</div>;
              },
            },
            {
              label: t("createdby"),
              key: `createdby.email`,
              sort: true,
              filter: {
                type: "text",
              },
            },
            {
              label: t("created"),
              key: `created`,
              sort: true,
              filter: {
                type: "text",
              },
              render: ({ created }) =>
                moment(created).format("YYYY-MM-DD HH:mm:ss"),
            },
          ]}
        />
      </div>
    </div>
  );
};

export default List;
